<wm-form-activity-editor
  [activity]="activity"
  [form]="form"
  [workflow]="workflow"
  (saved)="saved.emit($event)"
></wm-form-activity-editor>
